// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"QK-z","carouselContainer":"RK-z"};